export const VENDOR = 'nicVendor'
export const SPEED = 'nicSpeed'
export const COUNT = 'nicCount'
export const PROTOCOL_TYPE = 'nicProtocolType'
